import { z } from 'zod'

export const ADMINLLMPROMPTSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminLlmPromptsPostResponseSchema = z.unknown()
export type AdminLlmPromptsPostResponse = z.infer<typeof adminLlmPromptsPostResponseSchema>
